import { useCallback } from "react";
import { useBeforeUnload, useBlocker } from "react-router";

export function useNavigationBlocking(shouldBlock: boolean) {
  useBeforeUnload(
    useCallback(
      (event) => {
        if (shouldBlock) {
          event.preventDefault();
        }
      },
      [shouldBlock]
    ),
    { capture: true }
  );

  const blocker = useBlocker(
    useCallback(
      ({
        currentLocation,
        nextLocation,
      }: {
        currentLocation: { pathname: string };
        nextLocation: { pathname: string };
      }) => {
        return shouldBlock && currentLocation.pathname !== nextLocation.pathname;
      },
      [shouldBlock]
    )
  );

  return blocker;
}
